import React, { useEffect, useState } from "react";
import back from "../../assets/back.svg";
import { FaArrowDown } from "react-icons/fa6";
import { tokensImages } from "../../Constant";
import {
  FACTORY_Contract_Abi,
  FACTORY_Contract_Address,
  HopePepePairABI,
  ROUTER_Contract_Abi,
  ROUTER_Contract_Address,
} from "../../utilies/constant";
import useGetAmountOut from "../../hooks/useGetAmountOut";
import { useAccount } from "wagmi";
import { ethers } from "ethers";
import {
  prepareWriteContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";
import toast from "react-hot-toast";

export default function RemoveLiquidity({
  setIsAddLiquidity,
  setIsRemovedLiquidity,
  removeLiquidityValue,
}) {
  const [rangeValue, setRangeValue] = useState(0);
  const { address } = useAccount();
  const [receiveTokens, setReceiveTokens] = useState({ TokenA: 0, TokenB: 0 });
  const [Loading, setLoading] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [checkApproveValue, setcheckApproveValue] = useState(true)

  const {
    tokenBlnc: getPair,
    refetch: refetchGetPair,
    isLoading,
  } = useGetAmountOut(
    FACTORY_Contract_Address,
    FACTORY_Contract_Abi,
    0,
    "getPair",
    [removeLiquidityValue?.TokenAAddress, removeLiquidityValue?.TokenBAddress]
  );

  const { tokenBlnc: totalLiquidity, refetch: refetchTotalLiquidity } =
  useGetAmountOut(getPair, HopePepePairABI, 0, "totalSupply", []);

  const { tokenBlnc: userLiquidity, refetch: refetchUserLiquidity } =
    useGetAmountOut(getPair, HopePepePairABI, totalLiquidity, "balanceOf", [
      address,
    ]);

  const { tokenBlnc: reserves, refetch: refetchReserves } = useGetAmountOut(
    getPair,
    HopePepePairABI,
    userLiquidity,
    "getReserves",
    []
  );

  const { tokenBlnc: getTokenAPrice, refetch: refetchTokenAPrice } =
    useGetAmountOut(
      ROUTER_Contract_Address,
      ROUTER_Contract_Abi,
      userLiquidity,
      "getAmountsOut",
      [
        "1000000000000000000",
        [
          removeLiquidityValue?.TokenAAddress,
          removeLiquidityValue?.TokenBAddress,
        ],
      ]
    );

  const { tokenBlnc: getTokenBPrice, refetch: refetchTokenBPrice } =
    useGetAmountOut(
      ROUTER_Contract_Address,
      ROUTER_Contract_Abi,
      userLiquidity,
      "getAmountsOut",
      [
        "1000000000000000000",
        [
          removeLiquidityValue?.TokenBAddress,
          removeLiquidityValue?.TokenAAddress,
        ],
      ]
    );

  const { tokenBlnc: pairAllowance, refetch: refetchPairAllowance } =
    useGetAmountOut(getPair, HopePepePairABI, userLiquidity, "allowance", [
      address,
      ROUTER_Contract_Address,
    ]);



    const checkAllowance=()=>{
      const pairAllowanceValue = parseFloat(
        ethers.utils.formatUnits(pairAllowance?.toString() || "0")
      );
      const userLiquidityAmount = parseFloat(
        ethers.utils.formatUnits(userLiquidity?.toString() || "0")
      );
      const liquidityToRemove =
        (userLiquidityAmount * Number(rangeValue)) / 100;

        let result= Number(pairAllowanceValue)> Number(liquidityToRemove)
        setcheckApproveValue(result)



  }

  const handleApprove = async () => {
    try {
      const userLiquidityAmount = parseFloat(
        ethers.utils.formatUnits(userLiquidity?.toString() || "0")
      );
      if (Number(userLiquidityAmount) < 0) {
        toast.error("You have no LP Balance !");
        return;
      }
      setLoading(true);
      const { request } = await prepareWriteContract({
        address: getPair,
        abi: HopePepePairABI,
        functionName: "approve",
        args: [ROUTER_Contract_Address, Number(userLiquidity)],
        account: address,
      });
      const { hash } = await writeContract(request);
      const data = await waitForTransaction({
        hash,
      });
      toast.success(`Approve Tokens Successful`, {
        duration: 5000,
      });
      refetchPairAllowance()
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.log("Approve Fuc Error", error);
    }
  };

  const handleRemoveLiquidity = async () => {
    try {
      const { TokenAAddress, TokenBAddress, TokenAName, TokenBName } =
        removeLiquidityValue;
      const unixTime = Math.floor(Date.now() / 1000);
      const unixTimePlus300 = unixTime + 300;
      const userLiquidityAmount = parseFloat(
        ethers.utils.formatUnits(userLiquidity?.toString() || "0")
      );
      const liquidityToRemove =
        (userLiquidityAmount * Number(rangeValue)) / 100;
      let amountLiquidity = ethers.utils.parseEther(
        `${liquidityToRemove}`,
        "ethers"
      );
      if (TokenAName !== "AVAX" && TokenBName !== "AVAX") {
        setLoadingRemove(true);
        const { request } = await prepareWriteContract({
          address: ROUTER_Contract_Address,
          abi: ROUTER_Contract_Abi,
          functionName: "removeLiquidity",
          args: [
            TokenAAddress,
            TokenBAddress,
            Number(amountLiquidity),
            0,
            0,
            address,
            unixTimePlus300,
          ],
          account: address,
        });
        const { hash } = await writeContract(request);
        const data = await waitForTransaction({
          hash,
        });
        toast.success(`Liquidity Remove  Successfullly`, {
          duration: 5000,
        });
        refetchGetPair()
        refetchTotalLiquidity()
        refetchUserLiquidity()
        refetchReserves()
        refetchTokenAPrice()
        refetchTokenBPrice()
        refetchPairAllowance()
        setLoadingRemove(false);
      } else {
        setLoadingRemove(true);
        const { request } = await prepareWriteContract({
          address: getPair,
          abi: HopePepePairABI,
          functionName: "approve",
          args: [ROUTER_Contract_Address, Number(userLiquidity)],
          account: address,
        });
        const { hash } = await writeContract(request);
        const data = await waitForTransaction({
          hash,
        });
        toast.success(`Approve Tokens Successful`, {
          duration: 5000,
        });
        setLoadingRemove(false);
      }
    } catch (error) {
      setLoadingRemove(false);

      console.log("Remove Liquidity Fuc Error", error);
    }
  };

  const getAmounts = () => {
    // Format and parse inputs once
    const userLiquidityAmount = parseFloat(
      ethers.utils.formatUnits(userLiquidity?.toString() || "0")
    );
    const reservesA = parseFloat(
      ethers.utils.formatUnits(reserves[0]?.toString() || "0")
    );
    const reservesB = parseFloat(
      ethers.utils.formatUnits(reserves[1]?.toString() || "0")
    );
    const totalLiquidityAmount = parseFloat(
      ethers.utils.formatUnits(totalLiquidity?.toString() || "0")
    );

    // Calculate values
    const liquidityToRemove = (userLiquidityAmount * Number(rangeValue)) / 100;
    const amountA = (reservesA * liquidityToRemove) / totalLiquidityAmount;
    const amountB = (reservesB * liquidityToRemove) / totalLiquidityAmount;
    setReceiveTokens({
      TokenA: parseFloat(amountA).toFixed(2) || 0,
      TokenB: parseFloat(amountB).toFixed(2) || 0,
    });
  };

  const getPrecentageValue = (totalValue, balance) => {
    if (totalValue && balance) {
      let totalAmount = ethers.utils.formatUnits(totalValue?.toString() || "0");
      let balanceAmount = ethers.utils.formatUnits(balance?.toString() || "0");

      let calculateTotal = Number(balanceAmount) / Number(totalAmount);
      calculateTotal = Number(calculateTotal) * 100;
      return parseInt(calculateTotal);
    }
  };

  const pooledValue = (TokenSupply, TokenBalance, TotalReserve) => {
    if (TokenSupply && TokenBalance && TotalReserve) {
      let totalAmount = ethers.utils.formatUnits(
        TokenSupply?.toString() || "0"
      );
      let balanceAmount = ethers.utils.formatUnits(
        TokenBalance?.toString() || "0"
      );
      let TotalReserveA = ethers.utils.formatUnits(
        TotalReserve[0]?.toString() || "0"
      );
      let TotalReserveB = ethers.utils.formatUnits(
        TotalReserve[1]?.toString() || "0"
      );
      let shareValue = Number(balanceAmount) / Number(totalAmount);
      let PooledTokenA = Number(shareValue) * TotalReserveA;
      let PooledTokenB = Number(shareValue) * TotalReserveB;
      return {
        PooledTokenA: parseFloat(PooledTokenA).toFixed(3),
        PooledTokenB: parseFloat(PooledTokenB).toFixed(3),
      };
    }
  };

  useEffect(() => {
    refetchGetPair();
    if (getPair) {
      refetchTotalLiquidity();
    }
  }, [address]);

  useEffect(() => {
    if (userLiquidity) {
      getAmounts();
      checkAllowance()
    }

  }, [userLiquidity, rangeValue,pairAllowance]);
  return (
    <div>
      <div className="flex gap-3 items-center  mb-5 px-[20px]">
        <a
          href="javascript:void(0)"
          onClick={() => {
            setIsAddLiquidity(false);
            setIsRemovedLiquidity(false);
          }}
        >
          <img src={back} alt="" />
        </a>
        <div>
          <div className="text-[#000] text-[18px] font-[700]">
            Remove{" "}
            {`${removeLiquidityValue?.TokenAName || ""}-${
              removeLiquidityValue?.TokenBName || ""
            }`}{" "}
            Liquidty
          </div>
          <div className="text-[#8c8cb1] text-[14px] font-[500]">
            To receive {removeLiquidityValue?.TokenAName || ""} and{" "}
            {removeLiquidityValue?.TokenBName || ""}
          </div>
        </div>
        <div />
      </div>
      <div className="divide-y divide-[#000]-400"></div>
      <div className="mb-5 px-[20px]">
        <div className="flex justify-between items-center">
          <p className="font-[700] text-[16px] text-[green]">Amount</p>
          <p className="text-[16px] font-[700] ">Details</p>
        </div>
        <div className="flex justify-center items-center mt-4">
          <div className=" w-[90%] border border-[8c8cb1] rounded-[10px] p-[15px] bg-gray-100">
            <div className="text-[#000] font-[700] text-[20px] ">
              {rangeValue}%
            </div>
            <div className="mt-2">
              <input
                id="default-range"
                type="range"
                value={rangeValue}
                class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                onChange={(e) => setRangeValue(e.target.value)}
              />
            </div>
            <div className="flex gap-4 justify-center items-center">
              <button
                className="w-auto mt-4 px-[15px] h-[35px] bg-[green] rounded-[10px] flex items-center justify-center text-[#fff]"
                onClick={() => setRangeValue(25)}
              >
                25%
              </button>
              <button
                className="w-auto mt-4 px-[15px] h-[35px] bg-[green] rounded-[10px] flex items-center justify-center text-[#fff]"
                onClick={() => setRangeValue(50)}
              >
                50%
              </button>
              <button
                className="w-auto mt-4 px-[15px] h-[35px] bg-[green] rounded-[10px] flex items-center justify-center text-[#fff]"
                onClick={() => setRangeValue(75)}
              >
                75%
              </button>
              <button
                className="w-auto mt-4 px-[15px] h-[35px] bg-[green] rounded-[10px] flex items-center justify-center text-[#fff]"
                onClick={() => setRangeValue(100)}
              >
                MAX
              </button>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-5">
          <FaArrowDown style={{ fontSize: "16px", fontWeight: "700" }} />
        </div>
        <div className="font-[700] text-[16px] text-[green] ">RECEIVE</div>
        <div className="flex justify-center items-center mt-4">
          <div className=" w-[90%] border border-[8c8cb1] rounded-[10px] p-[15px] bg-gray-100">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <img
                  src={tokensImages[removeLiquidityValue?.TokenAName]}
                  alt="Token"
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                  }}
                />
                <p className="font-[500] text-[16px] ">
                  {removeLiquidityValue?.TokenAName}{" "}
                </p>
              </div>
              <p className="font-[500] text-[16] ">
                {receiveTokens?.TokenB || 0}
              </p>
            </div>
            <div className="flex justify-between mt-3">
              <div className="flex gap-2">
                <img
                  src={tokensImages[removeLiquidityValue?.TokenBName]}
                  alt="Token"
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                  }}
                />
                <p className="font-[500] text-[16px] ">
                  {removeLiquidityValue?.TokenBName}{" "}
                </p>
              </div>
              <p className="font-[500] text-[16] ">
                {receiveTokens?.TokenA || 0}
              </p>
            </div>
          </div>
        </div>

        <div className="font-[700] text-[16px] text-[green] mt-4 ">PRICES</div>
        <div className="flex justify-center items-center mt-4">
          <div className=" w-[90%] border border-[8c8cb1] rounded-[10px] p-[15px] bg-gray-100">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <img
                  src={tokensImages[removeLiquidityValue?.TokenAName]}
                  alt="Token"
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                  }}
                />
                <p className="font-[500] text-[16px] ">
                  1 {removeLiquidityValue?.TokenAName} =
                </p>
              </div>
              <p className="font-[500] text-[16] ">
                {parseFloat(
                  ethers.utils.formatUnits(getTokenBPrice[1]?.toString() || "0")
                ).toFixed(3)}{" "}
                {removeLiquidityValue?.TokenBName || "Token"}
              </p>
            </div>
            <div className="flex justify-between mt-3">
              <div className="flex gap-2">
                <img
                  src={tokensImages[removeLiquidityValue?.TokenBName]}
                  alt="Token"
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                  }}
                />
                <p className="font-[500] text-[16px] ">
                  1 {removeLiquidityValue?.TokenBName} =
                </p>
              </div>
              <p className="font-[500] text-[16] ">
                {parseFloat(
                  ethers.utils.formatUnits(getTokenAPrice[1]?.toString() || "0")
                ).toFixed(3)}{" "}
                {removeLiquidityValue?.TokenAName || "Token"}
              </p>
            </div>
          </div>
        </div>
        {/* <div className="flex justify-between items-center mt-4 ">
          <div className="font-[700] text-[16px] text-[green]  ">
            Slippage Tolerance
          </div>
          <div className="font-[700] text-[18px] ">0.5%</div>
        </div> */}
        <div className="flex justify-center ">
          <div className="flex justify-between w-[90%]">
            <button
              className={`w-auto mt-4 px-[45px] text-[18px] h-[45px] bg-[green] ${
                (Loading || rangeValue == 0 || checkApproveValue) && "bg-[lightgreen]"
              } rounded-[10px] flex items-center justify-center text-[#fff]`}
              onClick={handleApprove}
              disabled={Loading || rangeValue == 0 || checkApproveValue }
            >
              {Loading ? "Loading..." : "Enable"}
            </button>
            <button
              className={`w-auto mt-4 px-[25px] text-[18px] h-[45px] bg-[green]  ${
                (loadingRemove || rangeValue == 0 || checkApproveValue==false) && "bg-[lightgreen]"
              } rounded-[10px] flex items-center justify-center text-[#fff]`}
              onClick={handleRemoveLiquidity}
              disabled={loadingRemove || rangeValue == 0 || checkApproveValue==false}
            >
              {!address
                ? "Connect Wallet"
                : rangeValue == 0
                ? "Enter an amount"
                : checkApproveValue==false ? "Token not Approve " : loadingRemove
                ? "Loading.."
                : "Remove Liquidity"}
            </button>
          </div>
        </div>
        <div className="flex justify-center mt-4">
          <div className=" w-[90%] border border-[8c8cb1] rounded-[10px] p-[15px] bg-gray-100">
            <div className="text-sm">
              <p className="font-[700] text-[green] text-[16px] ">
                LP token in your Wallet
              </p>
              <div className="flex items-center justify-between mb-2 mt-2">
                <p className="flex items-center gap-1 font-[500]">
                  {removeLiquidityValue?.TokenAName && (
                    <img
                      src={tokensImages[removeLiquidityValue?.TokenAName]}
                      className="w-6 h-6 rounded-full"
                    />
                  )}
                  {removeLiquidityValue?.TokenBName && (
                    <img
                      src={tokensImages[removeLiquidityValue?.TokenBName]}
                      className="w-6 h-6 rounded-full"
                    />
                  )}
                  {`${removeLiquidityValue?.TokenAName}-${removeLiquidityValue?.TokenBName}`}{" "}
                  <p className="text-[green] font-[700] ">LP</p>:
                </p>
                <span className="font-[500]">
                  {isLoading
                    ? "Loading.."
                    : parseFloat(
                        ethers.utils.formatUnits(
                          totalLiquidity?.toString() || "0"
                        )
                      ).toFixed(3)}
                </span>
              </div>
              <p className="flex items-center justify-between mb-2 font-[500]">
                Share in Trading Pair:{" "}
                <span className="">
                  {`${
                    getPrecentageValue(totalLiquidity, userLiquidity) || 0
                  } %`}
                </span>
              </p>
              <p className="flex items-center justify-between mb-2 font-[500]">
                Pooled {removeLiquidityValue?.TokenAName || ""} :
                <span className="">
                  {pooledValue(totalLiquidity, userLiquidity, reserves)
                    ?.PooledTokenA || 0}
                </span>
              </p>
              <p className="flex items-center justify-between font-[500]">
                Pooled {removeLiquidityValue?.TokenBName || ""} :
                <span className="">
                  {" "}
                  {pooledValue(totalLiquidity, userLiquidity, reserves)
                    ?.PooledTokenB || 0}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
